import * as React from 'react';
import format from '../../lib/numbers/formatToDisplay';
import { i18n } from '../../i18n';

interface ResultsProps {
  high: number,
  low: number,
  medium: number
};

export default (props: ResultsProps) => (
  <div className='results'>
    <div>
      <h6 className='result result-high'>{format(props.high)}</h6>
      <h6 className='label result result-high'>{i18n.t('tool.results.high')}</h6>
    </div>
    <div className='result-medium-wrap'>
      <h6 className='result result-medium'>{format(props.medium)}</h6>
      <h6 className='label result result-medium'>{i18n.t('tool.results.medium')}</h6>
    </div>
    <div>
      <h6 className='result result-low'>{format(props.low)}</h6>
      <h6 className='label result result-low'>{i18n.t('tool.results.low')}</h6>
    </div>
  </div>
);
